import axios from 'axios';

const getList = (params) => axios.get('/fornecedor/produtos', {
  params,
});
const get = (id) => axios.get(`/fornecedor/produtos/${id}`, {});

const save = (produto) => {
  if (produto.id) {
    return axios.put(`/fornecedor/produtos/${produto.id}`, produto);
  }
  return axios.post('/fornecedor/produtos', produto);
};

const remover = (id) => axios.delete(`/fornecedor/produtos/${id}`);

export default {
  getList,
  get,
  save,
  remover,
};
